var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7632 0.4375L14.9922 7.66534L16.814 3.40448L24.7632 0.4375Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.260417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.22892 0.4375L11.9107 7.72483L10.1781 3.41192L2.22892 0.4375ZM21.2429 17.1909L18.6403 21.1618L24.2099 22.6936L25.8012 17.2802L21.2429 17.1909ZM1.19531 17.2802L2.77919 22.6936L8.33392 21.1618L5.74618 17.1909L1.19531 17.2802Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.260417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0467 10.4835L6.5 12.8184L12.0027 13.0712L11.8242 7.14467L8.0467 10.4909V10.4835ZM18.9628 10.4909L15.1258 7.07031L14.9994 13.0712L20.5021 12.8184L18.9628 10.4909ZM8.34414 21.1616L11.6829 19.5554L8.81261 17.3246L8.34414 21.1616ZM15.334 19.548L18.6505 21.1616L18.2043 17.3172L15.334 19.548Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.260417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6501 21.1609L15.3336 19.5547L15.6013 21.7111L15.5716 22.6258L18.6501 21.1609ZM8.34375 21.1609L11.4371 22.6258L11.4148 21.7111L11.6825 19.5547L8.34375 21.1609Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.260417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4857 15.8904L8.73438 15.0873L10.6826 14.1949L11.4931 15.8904H11.4857ZM15.5086 15.8904L16.3266 14.1875L18.2823 15.0798L15.5086 15.8978V15.8904Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.260417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33775 21.1636L8.82109 17.1927L5.75 17.2819L8.33775 21.1636ZM18.1756 17.1927L18.6441 21.1636L21.2467 17.2819L18.1756 17.1927ZM20.5031 12.8203L15.0004 13.0731L15.5061 15.8988L16.3241 14.1885L18.2797 15.0809L20.5031 12.8203ZM8.73186 15.0883L10.6801 14.196L11.4906 15.8914L12.0037 13.0657L6.50104 12.8203L8.73186 15.0883Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.260417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.8203L8.80518 17.3191L8.73081 15.0883L6.5 12.8203ZM18.2787 15.0883L18.1895 17.3191L20.4946 12.8203L18.2787 15.0883ZM12.0027 13.0731L11.4822 15.8988L12.1365 19.2302L12.2852 14.8355L12.0027 13.0731ZM14.992 13.0731L14.7243 14.828L14.8581 19.2302L15.5051 15.8914L14.992 13.0657V13.0731Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.260417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5082 15.889L14.8613 19.2278L15.3298 19.555L18.1927 17.3242L18.2819 15.0859L15.5082 15.889ZM8.734 15.0859L8.80836 17.3168L11.6787 19.5476L12.1397 19.2278L11.4928 15.889L8.72656 15.0859H8.734Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.260417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.579 22.6251L15.6013 21.7104L15.3485 21.5022H11.6602L11.4148 21.7104L11.4371 22.6251L8.34375 21.1602L9.42941 22.0525L11.623 23.562H15.3783L17.5793 22.045L18.6501 21.1602L15.5716 22.6251H15.579Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.260417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.325 19.5463L14.8566 19.2266H12.135L11.6739 19.5537L11.4062 21.7102L11.6516 21.502H15.3399L15.5927 21.7102L15.325 19.5537V19.5463Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.260417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.182 8.13381L26 4.15553L24.7656 0.4375L15.3218 7.42739L18.9581 10.4836L24.0889 11.9783L25.2192 10.6621L24.7284 10.3051L25.5092 9.59128L24.9143 9.13024L25.6951 8.53536L25.1746 8.13381H25.182ZM1 4.14809L1.83284 8.13381L1.29744 8.52792L2.0931 9.12281L1.49822 9.59128L2.27156 10.3051L1.78079 10.6621L2.91106 11.9783L8.04194 10.491L11.6782 7.41995L2.23438 0.4375L1 4.14809Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.260417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0835 11.98L18.9526 10.4928L20.4993 12.8203L18.1941 17.3191L21.2429 17.2819H25.8012L24.0835 11.98ZM8.03648 10.4854L2.9056 11.98L1.19531 17.2819H5.75361L8.80239 17.3191L6.49722 12.8203L8.04391 10.4854H8.03648ZM14.9892 13.0731L15.3238 7.42172L16.811 3.40625H10.1781L11.6653 7.42172L11.9999 13.0731L12.1263 14.8429V19.2302H14.8553L14.8702 14.8429L14.9892 13.0731Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.260417,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetamask);
export default __webpack_public_path__ + "static/media/icon-metamask.9cf4d80c193365067349a96fb48b1336.svg";
export { ForwardRef as ReactComponent };